<script setup>
import { computed } from 'vue';

const props = defineProps({
  widget: {
    type: Object,
    required: true,
  },
  widgetStyle: {
    type: Object,
    default: () => ({}),
  },
});

const items = computed(() => props.widget.properties?.items || []);
</script>

<template>
  <div class="h-full font-inter group">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="group/item flex items-start gap-4 p-4 rounded-xl border border-slate-100 bg-white hover:border-slate-300 hover:bg-slate-50/50 transition-all duration-200 cursor-pointer"
      >
        <div
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-slate-50 border border-slate-100 text-slate-400 group-hover/item:text-slate-900 group-hover/item:bg-white transition-all duration-200 shadow-sm"
        >
          <span class="text-xl" :class="[item.icon]" />
        </div>
        <div class="min-w-0 flex-1 pt-0.5">
          <div
            class="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-0.5"
          >
            {{ item.label }}
          </div>
          <div
            class="text-[13px] font-bold text-slate-900 truncate"
            :title="item.value"
          >
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
